<form class="form" [formGroup]="gradeActivityForm">
<div class="container">
  <br/>
  <ng-template #loading>
    <mat-progress-bar class="progress" mode="indeterminate"></mat-progress-bar>
  </ng-template>
  <div class="council-card" *ngIf="activity && council; else loading">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Council #{{council.id}} - {{council.name}}</mat-card-title>
        <mat-card-subtitle>{{getDioceseName(council.diocese)}} Diocese | {{council.location}} | Division {{council.division}}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div style="width: auto; text-align: center;">
          <button style="width: auto" mat-raised-button (click)="openCouncilSummary()">Open Council Summary <mat-icon style="width: auto">open_in_new</mat-icon></button>
        </div>
      </mat-card-content>
    </mat-card>
    <br/>
    <mat-card>
      <mat-card-header>
        <mat-card-title>Activity Information</mat-card-title>
        <mat-card-subtitle>{{getActivityName(activity.activityTypeId)}}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content class="description">
        <p *ngIf="activity.activityTitle"><strong>Title: </strong>{{activity.activityTitle}}</p>
        <strong>Brief Description:</strong>
        <p>{{activity.activityBriefDescription}}</p>
        <strong>Additional Information:</strong>
        <p>{{activity.activityDescription}}</p>
        <p *ngIf="activity.membersRecruited >= 0"><strong>Members Recruited: </strong>{{activity.membersRecruited}}</p>
        <p *ngIf="activity.activityDate"><strong>Activity Date: </strong>{{activity.activityDate}}{{activity.activityEndDate && activity.activityDate !== activity.activityEndDate ? " to " + activity.activityEndDate : ""}}</p>
        <p *ngIf="activity.submittedDate"><strong>Submitted: </strong>{{activity.submittedDate}}</p>
        <p *ngIf="activity.numberOfKnights"><strong>Number of Knights: </strong>{{activity.numberOfKnights}}</p>
        <p *ngIf="activity.totalKnightHours"><strong>Total Knight Hours: </strong>{{activity.totalKnightHours}}</p>
      </mat-card-content>
    </mat-card>
  <br/>
  <mat-card>
      <mat-card-header>
        <mat-card-title>Grading Information</mat-card-title>
      </mat-card-header>
      <mat-card-content class="container">
        <p>
          <mat-form-field>
            <mat-select placeholder="Activity Status" formControlName="activityStatus">
              <mat-option *ngFor="let activityStatus of this.getActivityStatuses()" [value]="activityStatus.id">
                {{activityStatus.displayName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field appearance="standard">
            <mat-label>Comments to Council</mat-label>
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows=5 cdkAutosizeMaxRows=10 placeholder="Please enter comments or feedback to the council" formControlName="programDirectorComments"></textarea>
          </mat-form-field>
        </p>
        <p>
          <mat-checkbox formControlName="isNotable">Flag as Notable</mat-checkbox>
        </p>
        <p *ngIf="isCouncilChoice">
          <mat-checkbox formControlName="isSupremeFeaturedProgram">Supreme Featured Program?</mat-checkbox>
        </p>
      </mat-card-content>
      <mat-card-actions>
        <button mat-raised-button color="primary" type="submit" [disabled]="gradeActivityForm.invalid || isSubmitting || !isAllowedToGrade" (click)="onSubmit()">Submit</button>
        <div *ngIf="isSubmitting">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      </mat-card-actions>
    </mat-card>

    <!-- <p>
        Form Status: {{ gradeActivityForm.status }}
    </p> -->
    <!-- <p>
        Form Value: {{ gradeActivityForm.value | json }}
    </p> -->
  </div>

  <!-- {{activity | json}} -->
</div>
</form>
